import emptyState from '../lottie/empty-state.json';
import loader from '../lottie/loader.json';
import cart from '../lottie/cart.json';
import detect from '../lottie/detect.json';
import gears from '../lottie/gears.json';
import clock from '../lottie/clock.json';
import emptyAlert from '../lottie/emptyAlert.json';


export const lottieMap = {
    emptyState: emptyState,
    loader: loader,
    cart: cart,
    detect: detect,
    gears: gears,
    clock,
    emptyAlert
};